import postRequest from 'utils/postRequest'
import deleteRequest from 'utils/deleteRequest'
import putRequest from 'utils/putRequest'
// import filterNullAndUndefinedFieldsFromObject from 'utils/filterNullAndUndefinedFieldsFromObject'
import filterUndefinedFromObject from 'utils/filterUndefinedFromObject'
import patchRequest from 'utils/patchRequest'

const path = '/api/site-specie-assesment-parameter'
const reassessmentPath = '/api/reassessment'

//eslint-disable-next-line
export const requestCreateSiteSpecieAssesmentParameter = (siteSpecieId, assesmentParameterTypeId, SeasonalDistributionId, siteHistoryId, specieHistoryId, signal) => {
  const url = siteHistoryId ? `${reassessmentPath}/species/${specieHistoryId}/parameters` : `${path}/${siteSpecieId}`
  return postRequest(url, {assesmentParameterTypeId, SeasonalDistributionId}, signal)
}

export const requestDeleteSiteSpecieAssesmentParameter = (siteSpecieParameterId, siteHistoryId, siteSpecieId, specieHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/species/${specieHistoryId}/parameters/${siteSpecieParameterId}` : `${path}/${siteSpecieParameterId}`
  return deleteRequest(url)
}

export const requestUpdateSiteSpecieAssesmentParameter = (siteSpecieParameterId, siteHistoryId, siteSpecieId, specieHistoryId, {
  minGlobal,
  bestGlobal,
  maxGlobal,
  sourceGlobalData,
  notes,
  minSite,
  bestSite,
  maxSite,
  sourceOfData,
  DerivationOfEstimateId,
  notesOnSiteDataForSpecies,
  SeasonalDistributionId,
  globallyMostImportant5,
  justification,
  regularlyHeld,
  regularlyOccurring,
  globallyMostImportant,
  aggregationPredictability,
  aggregationsAsCriteria,
  refugium,
  recruitmentSource,
  latestDataSetYear,
  earliestDataSetYear,
  speciesPresenceEvidence,
  yearPresenceEvidence,
  minReproductiveUnits,
  ruCompromisedOf,
  ruSource,
  regularlyHeldRestricted,
  minRegional,
  bestRegional,
  maxRegional,
  sourceRegionalData,
  sourceOfEu,
  euPopulation,
  nationalPopulation,
  sourceOfNational,
  unfavourable,
  concentrated,
  annexListed,
  migratory,
  annexListedMi
}) => {

  const requestBody = filterUndefinedFromObject({
    minGlobal,
    bestGlobal,
    maxGlobal,
    sourceGlobalData,
    notes,
    minSite,
    bestSite,
    maxSite,
    sourceOfData,
    DerivationOfEstimateId,
    notesOnSiteDataForSpecies,
    SeasonalDistributionId,
    globallyMostImportant5,
    justification,
    regularlyHeld,
    regularlyOccurring,
    globallyMostImportant,
    aggregationPredictability,
    aggregationsAsCriteria,
    refugium,
    recruitmentSource,
    latestDataSetYear,
    earliestDataSetYear,
    speciesPresenceEvidence,
    yearPresenceEvidence,
    minReproductiveUnits,
    ruCompromisedOf,
    ruSource,
    regularlyHeldRestricted,
    minRegional,
    bestRegional,
    maxRegional,
    sourceRegionalData,
    sourceOfEu,
    euPopulation,
    nationalPopulation,
    sourceOfNational,
    unfavourable,
    concentrated,
    annexListed,
    migratory,
    annexListedMi
  })

  if (siteHistoryId){
    return patchRequest(`${reassessmentPath}/species/${specieHistoryId}/parameters/${siteSpecieParameterId}`, requestBody)
  }
  return putRequest(`${path}/${siteSpecieParameterId}`, requestBody)
}
